export const planConstants = {
  CHANGE_PLAN_SUCCESS: 'SEND_PLAN_SUCCESS',
  CHANGE_PLAN_REQUEST: 'SEND_PLAN_REQUEST',
  CHANGE_PLAN_FAILURE: 'SEND_PLAN_FAILURE',
};
